<template>
  <li class="card-body">
    <router-link
      :to="{ path: '/message', query: { cid: inbox.id, pid: inbox.professional_chat.id }}"
      class="text-message">
      <div class="row">
        <div class="col-md-1 col-2">
          <div class="avatar-container small">
            <div :class="['dot', (inbox.professional_chat.active === 1) ? 'active' : 'inactive']"></div>
            <img v-lazy="inbox.professional_chat.picture"
                 class="rounded-circle message-user-img" alt="beneat cleaner">
          </div>
        </div>
        <div class="col-md-2 col-7">
          {{ inbox.professional_chat.name | firstName }}
          <div class="d-block d-xl-none d-lg-none d-md-none">
            <div v-if="inbox.message_type_id === 1">
              <label v-if="inbox.is_read === 0">{{ inbox.message }}</label>
              <span v-else>{{ inbox.message }}</span>
            </div>
            <div v-else-if="inbox.message_type_id === 2">
                <span v-if="inbox.sender_type === 'user'">
                  <lable v-if="inbox.is_read === 0">
                    {{ $t('message.inbox.you_sent_photo') }}
                  </lable>
                  <span v-else>
                    {{ $t('message.inbox.you_sent_photo') }}
                  </span>
                </span>
              <span v-else>
                  <label v-if="inbox.is_read === 0">
                    {{ $t('message.inbox.sent_photo') }}
                  </label>
                  <span v-else>
                    {{ $t('message.inbox.sent_photo') }}
                  </span>
                </span>
            </div>
            <div v-else-if="inbox.message_type_id === 3">
              <span v-if="inbox.sender_type === 'user'">
                {{ $t('message.inbox.you_sent_location') }}
              </span>
              <span v-else>
                {{ $t('message.inbox.sent_location') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-7 d-none d-md-block">
          <div v-if="inbox.message_type_id === 1">
            <label v-if="inbox.is_read === 0">{{ inbox.message }}</label>
            <span v-else>{{ inbox.message }}</span>
          </div>
          <div v-else-if="inbox.message_type_id === 2">
            <span v-if="inbox.sender_type === 'user'">
              <label v-if="inbox.is_read === 0">
                {{ $t('message.inbox.you_sent_photo') }}
              </label>
              <span v-else>
                {{ $t('message.inbox.you_sent_photo') }}
              </span>
            </span>
            <span v-else>
            <label v-if="inbox.is_read === 0">
              {{ $t('message.inbox.sent_photo') }}
            </label>
            <span v-else>
              {{ $t('message.inbox.sent_photo') }}
            </span>
          </span>
          </div>
          <div v-else-if="inbox.message_type_id === 3">
            <span v-if="inbox.sender_type === 'user'">
              {{ $t('message.inbox.you_sent_location') }}
            </span>
            <span v-else>
              {{ $t('message.inbox.sent_location') }}
            </span>
          </div>
        </div>
        <div class="col-md-2 col-3 message-time">
          {{ inbox.create_date | timeSpan }}
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
  export default {
    props: ['inbox']
  }
</script>

<style scoped>
  .card-body {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/inbox/Inbox.vue